// Get user permissions from localStorage
export const getUserPermissions = () => {
  const permissions = localStorage.getItem("userPermissions");
  return permissions ? JSON.parse(permissions) : [];
};

// Check if user has permission for a specific page
export const hasPermission = (pagePath) => {
  const permissions = getUserPermissions();
  return permissions.includes(pagePath);
};

// Check if user has any permissions (for authentication)
export const hasAnyPermissions = () => {
  const permissions = getUserPermissions();
  return permissions.length > 0;
};

// Get menu items based on user permissions
export const getMenuItems = () => {
  const menuItems = [
    {
      path: '/bookings',
      label: 'Bookings',
      icon: 'bi-calendar-check',
      permission: 'bookings'
    },
    {
      path: '/bookings/cancelled',
      label: 'Cancelled',
      icon: 'bi-calendar-x',
      permission: 'bookings/cancelled'
    },
    {
      path: '/bookings/add',
      label: 'Add Booking',
      icon: 'bi-plus-circle',
      permission: 'bookings/add'
    },
    {
      path: '/bookings/topagents',
      label: 'Top Agents',
      icon: 'bi-graph-up',
      permission: 'bookings/topagents'
    },
    {
      path: '/users',
      label: 'Users',
      icon: 'bi-people-fill',
      permission: 'users'
    },
    {
      path: '/agencies',
      label: 'Agencies',
      icon: 'bi-building',
      permission: 'agencies'
    },
    {
      path: '/followup-status',
      label: 'Follow-up Status',
      icon: 'bi-flag-fill',
      permission: 'followup-status'
    },
    {
      path: '/agent-statement',
      label: 'Agent Statement',
      icon: 'bi-file-earmark-text',
      permission: 'agentstatement'
    },
    {
      path: '/driver-details',
      label: 'Driver Details',
      icon: 'bi-truck',
      permission: 'driverdetails'
    },
    {
      path: '/driver-management',
      label: 'Driver Management',
      icon: 'bi-person-badge',
      permission: 'driver-management'
    },
    {
      path: '/vehicle-management',
      label: 'Vehicle Management',
      icon: 'bi-bus-front',
      permission: 'vehicle-management'
    },
    {
      path: '/route-management',
      label: 'Route Management',
      icon: 'bi-geo-alt',
      permission: 'route-management'
    }
  ];

  // Filter menu items based on user permissions
  return menuItems.filter(item => hasPermission(item.permission));
}; 